/** @jsx jsx */
import { Container, Title, View } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import gql from 'graphql-tag';
import { jsx } from 'theme-ui';
import EventBannerImage from './EventBannerImage';

export default function EventBanner({ event, withOverlay = true, ...rest }) {
  return (
    <View>
      <EventBannerImage event={event} withOverlay={withOverlay}>
        <Container {...rest}>
          {withOverlay && event?.name && (
            <Title variant="banner">{event.name}</Title>
          )}
        </Container>
      </EventBannerImage>
    </View>
  );
}

export const fragment = graphql`
  fragment bb_EventBanner on Bottlebooks_Event {
    name
    ...bb_EventBannerImage
  }
  fragment EventBanner on Event {
    name
    ...EventBannerImage
  }
`;
EventBanner.fragment = gql`
  fragment EventBanner on Event {
    name
    ...EventBannerImage
  }
  ${EventBannerImage.fragment}
`;
